import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { PermissionsV2 } from 'constants/permissions_v2';
import { DEBIT_TRANSACTION_STATUSES, DEBIT_TXN_TAB_CONFIG } from 'modules/debit-transactions/constants/constants';
import DebitTransactionTable from 'modules/debit-transactions/DebitTransactionTable';
import PermissionWrapper from 'components/hoc/PermissionWrapper';

function DebitTransactions() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const activeTab = Number(queryParams.get('tab')) || 0;

  return (
    <Box mt={6} mb={3}>
      <Tabs
        isFitted
        variant='enclosed-colored'
        isLazy
        index={activeTab}
        onChange={(tab) => {
          queryParams.set('tab', tab);
          history.push({ search: queryParams.toString() });
        }}
      >
        <TabList>
          {DEBIT_TXN_TAB_CONFIG.map(({ title, status }, index) => (
            <PermissionWrapper
              permission={
                status === DEBIT_TRANSACTION_STATUSES.IN_REVIEW
                  ? PermissionsV2.VIEW_DEBIT_TRANSACTIONS_COMPLIANCE_OPERATIONS
                  : PermissionsV2.VIEW_DEFIT_RFI_REQUESTED_COMPLIANCE_OPERATIONS
              }
              key={index}
            >
              <Tab>{title}</Tab>
            </PermissionWrapper>
          ))}
        </TabList>

        <TabPanels>
          {DEBIT_TXN_TAB_CONFIG.map(({ title, status }, index) => (
            <TabPanel key={index}>
              <DebitTransactionTable title={title} status={status} />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default DebitTransactions;
